<template>
  <v-row justify="center" align="start">
    <v-col cols="12">
      <v-banner icon="content_copy">
        Recreate Order {{ tdId }}
        <template v-slot:actions>
          <v-btn text color="blue darken-2" exact @click="$router.go(-1)">
            <v-icon left>arrow_back</v-icon>Back
          </v-btn>
        </template>
      </v-banner>
    </v-col>

    <v-col cols="12" lg="8">
      <v-card outlined shaped>
        <v-card-title>
          <v-icon class="mr-2">info</v-icon>How It Works
        </v-card-title>
        <v-card-text
          >After confirming your order date a new basket containing the products
          from your previous order will be created, you can amend these products
          and addtional products can be added to this basket in the normal
          way.</v-card-text
        >
      </v-card>
    </v-col>

    <v-col cols="12" lg="8">
      <v-form ref="createOrderForm" v-model="valid" @submit.prevent="submit()">
        <Date
          v-model="orderDate"
          :order="this.$store.getters.retrieveCurrentTemplate"
          :template="true"
        ></Date>
        <Reference
          v-model="custRef"
          :order="this.$store.getters.retrieveCurrentTemplate"
          :template="true"
        ></Reference>

        <v-btn
          :loading="loading"
          block
          color="blue darken-2"
          outlined
          x-large
          type="submit"
          :disabled="!valid"
          >Confirm Date</v-btn
        >
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";

import Date from "@/components/order/Date.vue";
import Reference from "@/components/order/Reference.vue";

export default {
  components: {
    Date,
    Reference,
  },

  data() {
    return {
      valid: false,
      orderDate: null,
      custRef: null,
      loading: false,
    };
  },

  computed: {
    tdId() {
      console.log("-- Current TDID");
      return parseInt(this.$route.params.td_id);
    },
  },

  methods: {
    ...mapActions(["setSelectedTrolly", "reincarnateOrder"]),

    async submit() {
      this.loading = true;

      if (this.$refs.createOrderForm.validate()) {
        let orderObject = {
          tdId: this.tdId,
          orderDate: this.orderDate,
          custRef: this.custRef,
        };

        let response = await this.reincarnateOrder(orderObject);

        if (response) {
          await this.setSelectedTrolly(response.trollyId);

          this.$router.push({ name: "OrdersBasket" }).catch((e) => {
            console.log(e);
          });
        }
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>